import React, { useState } from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import alertNotificationImg from '../../assets/img/alertnotification.png'
import dangerNotificationImg from '../../assets/img/dangernotification.png'

const NotificationModal = ({ open, toggle, notificationData }) => {
  console.log(notificationData)
  const getBackgroundColor = (type) => {
    switch (type) {
      case 'alert':
        return  'rgba(255, 255, 255, 1)'; 
      case 'danger':
        return  'rgba(255, 255, 255, 1)'; 
      default:
        return  'rgba(255, 255, 255, 1)';  // Default light gray with opacity
    }
  };
  const backgroundColor = getBackgroundColor(notificationData?.type);
    return (
    <div>
        <Modal isOpen={open} toggle={toggle} className={`custom-right-modal`} >
            <ModalHeader toggle={toggle} style={{ textTransform: 'capitalize' }} >
                <div style={{ backgroundColor: `${backgroundColor} !important`, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                    {notificationData?.type ==='alert' ? <img src={alertNotificationImg} alt="" /> : <img src={dangerNotificationImg} alt="" />}{notificationData?.type}
                </div>
            </ModalHeader>
            <ModalBody>
                <h6 style={{ textAlign: 'start', marginBottom: "15px" }} >{notificationData?.message}</h6>
                <div>
                    <div style={{ marginBottom: '10px' }} >Images:</div>
                    {notificationData?.image_urls?.map((url) => 
                        url ? (
                            <div key={url} style={{ display: 'flex', flexDirection: 'column', marginBottom: '5px', alignItems: 'center' }}>
                                <img key={url} style={{ maxWidth: '500px', maxHeight: '500px'}} src={url} alt="Image preview"/>
                            </div>
                        ) : (
                            <div style={{ fontWeight: 100, fontSize: 'small' }} >
                                No images to display
                            </div>
                        )
                    )}
                </div>
            </ModalBody>
        </Modal>
    </div>
  )
}

export default NotificationModal